export default __webpack_public_path__ + "static/media/accelerating.a4ca10b9.svg";